module.exports = __webpack_public_path__ + "static/img/logo-6.ea95983.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg/logo-6.png
// module id = CufH
// module chunks = 1